import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button, Table } from "antd";
import { createUseStyles } from "react-jss";
import { OutletDeleteRequest } from "../../../../services/dto/outlet";
import { useAuth } from "../../../../uiComponent/authProvider/AuthContext";
import { useState } from "react";
import { Action } from "../../../../common/enum";
import OutletService, {
  OutletServiceAction,
} from "../../../../services/outletService";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  card: {
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  details: {
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
});

export default function OutletMultipleDeleteReview() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state as any;
  const { loginData } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!loginData?._csrf) {
      return;
    }
    let successData: any[] = [];

    data.forEach(async (it: any) => {
      const request: OutletDeleteRequest = {
        code: it?.code,
        action: Action.DELETE,
      };

      try {
        await OutletService(
          OutletServiceAction.DELETE,
          request,
          loginData?._csrf
        );

        const successContent = {
          code: it?.code,
          name: it?.name,
          status: "Delete Success",
        };
        successData.push(successContent);
      } catch (error) {
        const successContent = {
          code: it?.code,
          name: it?.name,
          status: "Delete Failed",
        };
        successData.push(successContent);
      }
    });
    setTimeout(() => {
      navigate("/outlet/multiple-delete/success", {
        state: { data: successData },
      });
    }, 1000);
    setLoading(false);
  };

  const columns = [
    {
      title: "Kode",
      dataIndex: "code",
      key: "code",
      sorter: (a: any, b: any) => a.code.localeCompare(b.code),
    },
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
  ];

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <h2>Outlet Delete Review</h2>
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: true }}
          pagination={{
            position: ["bottomRight"],
            pageSizeOptions: ["10", "50", "100"],
            showSizeChanger: true,
            defaultPageSize: 10,
          }}
        />
        <div className={classes.buttonContainer}>
          <Button
            onClick={() => navigate("/outlet")}
            type="default"
            loading={loading}
          >
            Back
          </Button>
          <Button onClick={handleSubmit} type="primary" loading={loading}>
            Submit
          </Button>
        </div>
      </Card>
    </div>
  );
}
